import {ChangeEventHandler, useState} from 'react'

import AddLineIcon from 'remixicon-react/AddLineIcon'
import SubtractLineIcon from 'remixicon-react/SubtractLineIcon'
import styled from 'styled-components'
import {ifProp} from 'styled-tools'

import {FacetTreeItem} from '@festi/common/api/algolia'
import {Expandable} from '@festi/common/components/common'
import {styledTheme} from '@festi/common/themes'

import FacetCheckboxItem from './FacetCheckboxItem'
import {flattenFacetTreeValues} from './facets'

interface WrapperProps {
  padding: boolean
}

const FacetWrapper = styled.div<WrapperProps>`
  padding-left: ${ifProp('padding', '24px', '0px')};
`

const Line = styled.div`
  display: flex;
  align-items: center;
`

const FacetButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 0;
`

const FacetLabel = styled.span`
  margin-left: 16px;
`

const FacetIconContainer = styled.div`
  width: 16px;
  height: 16px;
  border: 1px solid ${styledTheme.palette.ui20Solid};
  box-sizing: border-box;
`

interface Props {
  option: FacetTreeItem
  onChange: ChangeEventHandler<HTMLInputElement>
  level: number
}

export default function FacetItem({option, onChange, level}: Props) {
  const {value, count, active, label, children} = option
  const hasChildren = children?.length > 0
  const hasActiveChildren = flattenFacetTreeValues(children).some(
    (child) => child.active,
  )
  const [isOpen, setIsOpen] = useState<boolean>(hasActiveChildren)
  const nextLevel = level + 1

  return (
    <FacetWrapper padding={level > 0}>
      <Line>
        {hasChildren ? (
          <FacetButton onClick={() => setIsOpen(!isOpen)}>
            <FacetIconContainer>
              {!isOpen ? (
                <AddLineIcon size={14} color={styledTheme.palette.lightBlue} />
              ) : (
                <SubtractLineIcon
                  size={14}
                  color={styledTheme.palette.lightBlue}
                />
              )}
            </FacetIconContainer>
            <FacetLabel>{label}</FacetLabel>
          </FacetButton>
        ) : (
          <FacetCheckboxItem
            key={value}
            count={count}
            onChange={onChange}
            checked={active}
            value={value}
          >
            {label}
          </FacetCheckboxItem>
        )}
      </Line>
      {hasChildren && (
        <Expandable expanded={isOpen}>
          {children?.map((o: FacetTreeItem) => (
            <FacetItem
              key={o.value}
              option={o}
              onChange={onChange}
              level={nextLevel}
            />
          ))}
        </Expandable>
      )}
    </FacetWrapper>
  )
}
